import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBasePublicQuery } from 'config/axiosBaseQuery';
import { endpoints } from 'config/api';
import {
  ILeadTemplate,
  LeadFormResponse,
  SubmitLeadFormDto,
} from './leadsTemplatesTypes';

export interface SubmitLeadFormResponse {
  success: boolean;
  message: string;
}

export const leadsTemplatesPublicApi = createApi({
  reducerPath: 'leadsTemplatesPublicApi',
  baseQuery: axiosBasePublicQuery(),
  endpoints: (builder) => ({
    fetchPublicLeadTemplate: builder.query<ILeadTemplate, string>({
      query: (id) => ({
        url: `${endpoints.leadsTemplates.base}/${id}`,
        method: 'GET',
      }),
      transformResponse: (response: LeadFormResponse) => response.data,
    }),

    submitLeadTemplate: builder.mutation<
      SubmitLeadFormResponse,
      { id: string; submission: SubmitLeadFormDto }
    >({
      query: ({ id, submission }) => ({
        url: `${endpoints.leadsTemplates.base}/${id}/submit`,
        method: 'POST',
        data: submission,
      }),
      transformResponse: (response: SubmitLeadFormResponse) => response,
    }),
  }),
});

export const {
  useFetchPublicLeadTemplateQuery,
  useSubmitLeadTemplateMutation,
} = leadsTemplatesPublicApi;
